import { render, staticRenderFns } from "./GeneralNaplata.vue?vue&type=template&id=6636f498"
import script from "./GeneralNaplata.vue?vue&type=script&lang=js"
export * from "./GeneralNaplata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports